import { NotLogin, Loading, InfoToast } from "../../shared/index";
import Headings from "../../constants/headings";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import React, { useEffect, useState, useMemo } from 'react'
import AdapterJalali from '@date-io/date-fns-jalali';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getCustomerEmailHistory } from '../../api/requestAxios/userInfo'
import ToPersianNumber from '../../functions/extensions/toPersianNumber'
import DateToPersianNumber from '../../functions/extensions/dateToPersianNumber'
import { useNavigate } from "react-router";
import CustomValuesHook from '../../functions/myHooks/CustomValuesHook'
import moment from 'moment-jalaali'
import momentEn from 'moment';
import './style.scss'
import { Navigate } from "react-router";
// import GSPTable, { InputFilter } from 'azm-components'
import GSPTable from '../../shared/GSFTable'

import UserInfo from "../user_info";
import { Link } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
// import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';



const ChangeEmailList = (props) => {


    const navigate = useNavigate();
    const [emailList, setEmailList] = useState({
        pageIndex: 1,
        pageNumber: 1,
        pageSize: 25,
        totalCount: 0,
        data: []
    });
    const [showUserInfo, setShowUserInfo] = useState(false)
    const [loading, setLoading] = useState(false)
    const [userId, setUserId] = useState('')
    const [value, setValue] = useState([null, null]);


    const HelpicalEmailCompo = ({ item, listData, setListData }) => {
        if (item.HelpicalEmail) {
            return <span className="active">موفق</span>
        } else {
            return <span className="deactive" >ناموفق</span>
        }
    }

    const options = ({ item }) => {
        return <div className='d-flex flex-row justify-content-center options-container' >
            <span className="view-user" onClick={(e) => { clickOptions(e, item) }}> {Headings.options}</span>
        </div>
    }

    const columns = [
        { title: 'ردیف', property: 'row', filterProperty: 'null', hasSort: false, hasFilter: false, display: true },
        { title: 'مشترک', property: 'CustomerFirstName', filterProperty: null, hasSort: true, hasFilter: false, display: true },
        { title: 'از ایمیل', property: 'PreviousEmail', filterProperty: null, hasSort: true, hasFilter: true, display: true },
        { title: 'به ایمیل', property: 'CurrentEmail', filterProperty: null, hasSort: false, display: true },
        {
            title: 'ویرایش در هلپی‌کال', property: 'HelpicalEmail', filterProperty: null, hasSort: false, display: true, component: HelpicalEmailCompo,
        },
        { title: 'تاریخ تغییر', property: 'LastModifiedDate', filterProperty: null, hasSort: false, display: true },
        { title: 'گزینه ها', property: 'LastModifiedDate', filterProperty: null, hasSort: false, display: true, component: options },


    ]

 


    useEffect(() => {
        if (value[0] && value[1]) {
            let obj = {
                CustomerId: '',
                StartDate: moment(new Date(value[0])).local('en').format('YYYY-MM-DD HH:MM'),
                EndDate: moment(new Date(value[1])).local('en').format('YYYY-MM-DD HH:MM')
            }
            getEmail(obj);
        }
        else {
            let obj = {}
            getEmail(obj);
        }
    }, [value])

    const getEmail = async (obj) => {
        try {
            const emails = await getCustomerEmailHistory(obj)
            let newEmails = []
            emails.data.forEach((item, index) => {
                let obj1 = {}
                obj1.CustomerFirstName = item.CustomerFirstName + ' ' + item.CustomerLastName
                obj1.CustomerId = item.CustomerId
                item.EmailHistoryLists.forEach((itemHistoy, indexHistory) => {
                    let obj2 = {}
                    obj2.CurrentEmail = itemHistoy.CurrentEmail
                    obj2.PreviousEmail = itemHistoy.PreviousEmail
                    obj2.LastModifiedDate = itemHistoy.LastModifiedDate
                    obj2.HelpicalEmail = itemHistoy.HelpicalEmail

                    let finalObj = {}
                    // finalObj.row = indexHistory+index + 1
                    finalObj.CustomerFirstName = obj1.CustomerFirstName
                    finalObj.CustomerId = obj1.CustomerId

                    finalObj.CurrentEmail = obj2.CurrentEmail
                    finalObj.PreviousEmail = obj2.PreviousEmail
                    finalObj.LastModifiedDate = moment(obj2.LastModifiedDate).local('fa').format(' jYYYY-jMM-jDD HH:MM')
                    finalObj.HelpicalEmail = obj2.HelpicalEmail
                    newEmails.push(finalObj)
                })

            })
            newEmails.forEach((item, index) => {
                item.row = ToPersianNumber(index + 1)
            });
            let temp = { ...emailList }
                        temp.data = newEmails
            setLoading(false)
            setEmailList({ ...temp });
        } catch (error) {

        }
    }

    const clickOptions = (e, item) => {
        localStorage.setItem('UserIdFromChangeEmail', item?.CustomerId)
        setShowUserInfo(true)
        props?.setUserId(item.CustomerId)

    }


    return (
        <>
            {!showUserInfo ? <main className="change-email">
                <div className="top-margin"></div>
                <div className="user-info-container user-docs-container">
                    <div className="user-info">
                    </div>
                    <Row className="d-flex flex-row justify-content-start">
                        {/* <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                                className='datePicker'
                                label={Headings.ReportFrom}
                                value={valueStart}
                                onChange={(newValue) => {
                                    setValueStart(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                                className='datePicker'
                                label={Headings.ReportTo}
                                value={valueEnd}
                                onChange={(newValue) => {
                                    setValueEnd(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider> */}
                        <LocalizationProvider
                            dateAdapter={AdapterJalali}
                            localeText={{ start: 'ازتاریخ', end: 'تا تاریخ' }}
                        >
                            <DateRangePicker
                                startText="از تاریخ"
                                endText="تا تاریخ"
                                value={value}
                                onChange={(newValue) => {
                                    setValue(newValue);
                                }}
                                renderInput={(startProps, endProps) => (
                                    <React.Fragment>
                                        <TextField {...startProps} />
                                        <span style={{ margin: '0px 10px' }}>تا</span>
                                        {/* <DateRangeDelimiter> to </DateRangeDelimiter>  */}
                                        <TextField {...endProps} />
                                    </React.Fragment>
                                )}
                            />
                        </LocalizationProvider>
                    </Row>
                    <div className="email-list-table-container">
                        <div className="table-change-email">
                            {emailList?.data?.length > 0 ?
                                <GSPTable
                                    // apiCall={getEmail}
                                    columns={columns}
                                    hasSorting={false}
                                    dataList={emailList}
                                    // options={options}
                                    hasFiltering={false}
                                    isSearchByExternalBtn={false}
                                    loading={loading}
                                    enableScrolling={false}
                                    searchBtnText={'جستجو'}
                                    isStepScrolling={false}
                                // setDataListFromItem={setEmailList}

                                /> :
                                <p className="no-data">{Headings.NoData}</p>
                            }
                        </div>
                    </div>
                </div>
            </main > :
                <div>
                    {/* <UserInfo login={props.login} token={props.token} userId={userId} /> */}
                    <Navigate to={"/user-info"} state={{ login: props?.login, token: props?.token }} />
                </div>
            }
        </>


    )
}

export default ChangeEmailList